import {
    createEntityAdapter,
    createSlice
} from '@reduxjs/toolkit';
export const TAB_KEY_GRID = 'tab.key.grid';
export const TAB_TYPE_ENUM = {
  EDIT: {
    type: 'edit',
  },
  NEW: {
    type: 'new',
  },
};
const tabsAdaptor = createEntityAdapter({
  selectId: (tab) => tab.key,
});
const initialState = tabsAdaptor.getInitialState({
  activeKey: TAB_KEY_GRID,
});

const koganTabsSlice = createSlice({
  name: 'koganTabs',
  initialState,
  reducers: {
    addTab: tabsAdaptor.upsertOne,
    removeTab: tabsAdaptor.removeOne,
    updateTab: tabsAdaptor.upsertOne,
    setActiveTab: (state, action) => {
      state.activeKey = action.payload.key;
    },
  },
});


//Actions
export const { addTab, removeTab, updateTab, setActiveTab } =
  koganTabsSlice.actions;

//Define selectors here
export const {selectAll,selectById} = tabsAdaptor.getSelectors((state) => state.koganTabs);
export const getActiveTab = (state) => state.koganTabs.activeKey;


// Global Helper functions
export const getTabKey = (product) => {
    return `tab.key.sku.${product.product_sku}`;
  };
export const createTab = (child, type, status) => {
    return {
      childId:child.product_sku,
      images: [],
      type,
      key: getTabKey(child),
      status,
    };
  };


export default koganTabsSlice.reducer;
